export enum TriggerType {
  MessageReceived = 'message:appUser',
  ConversationOpened = 'conversation:open',
  WidgetLoaded = 'widget:load',
  Unknown = 'unknown',
}

export interface TriggerItem {
  type: TriggerType;
  icon: string;
  description: string;
}

const triggers: { [key: string]: TriggerItem } = {
  [TriggerType.MessageReceived]: {
    type: TriggerType.MessageReceived,
    icon: 'comment',
    description: 'Message Received',
  },
  [TriggerType.WidgetLoaded]: {
    type: TriggerType.WidgetLoaded,
    icon: '#web-assistant-alt',
    description: 'Page Loaded',
  },
  [TriggerType.ConversationOpened]: {
    type: TriggerType.ConversationOpened,
    icon: '#conversation',
    description: 'Conversation Opened',
  },
  [TriggerType.Unknown]: {
    type: TriggerType.Unknown,
    icon: '#unknown',
    description: 'Unknown Intent',
  },
};

export const AvailableTriggers = {
  get: (key: string) => triggers[key],
  list: () => Object.values(triggers),
};
